import React, { useContext } from "react"
import UserContext from "../../UserContext"
import { openResourcePreviewModal } from "./ResourcePreviewModal"

export default function DiffusionAdCardItem({ ad, onClick }) {
  const userContext = useContext(UserContext)

  return (
    <div className="m-3 d-flex align-items-stretch">
      <button
        type="button"
        className="btn btn-light p-0"
        style={{ flex: 1, minWidth: 0, overflow: "hidden" }}
        onClick={() => onClick(ad)}
      >
        <div className="info-box bg-transparent mb-0 p-0">
          <div className="info-box-content" style={{ minWidth: 0 }}>
            <div className="d-flex align-items-center">
              <span className="text-truncate text-left" style={{ flex: 1, minWidth: 0 }}>
                {ad.adTypeId === 1 && <i className="fas fa-film"></i>}
                {ad.adTypeId === 2 && <i className="far fa-image"></i>}
                {ad.adTypeId === 3 && <i className="far fa-file-pdf"></i>} <b>{ad.name}</b>
              </span>
              <span className="ml-2" style={{ whiteSpace: "nowrap" }}>
                <i className="far fa-play-circle"></i> <em>{ad.duration > 0 ? ad.duration : "~"}s</em>
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <span></span>
              <span>
                <i className="fas fa-expand-arrows-alt"></i> {ad.width}x{ad.height}
              </span>
            </div>
          </div>
        </div>
      </button>
      <button
        type="button"
        className="btn btn-light ml-1 px-2 d-flex align-items-center"
        title="Prévisualiser"
        onClick={(e) => {
          e.stopPropagation()
          openResourcePreviewModal(ad, userContext)
        }}
      >
        <i className="far fa-eye"></i>
      </button>
    </div>
  )
}
